import { UnifiedFieldIcon } from '@modules/common/components/UnifiedFieldIcon';
import { UNIFIED_FIELD_HELP_CENTER_DOC } from '@modules/common/constants';
import { Box, Button, Link, Paper, Stack, Typography } from '@mui/material';

interface EditUnifiedFieldDrawerHeaderProps {
  name: string;
}

export const EditUnifiedFieldDrawerHeader = ({
  name,
}: EditUnifiedFieldDrawerHeaderProps) => {
  return (
    <Paper>
      <Stack
        direction="row"
        px={3}
        py={2}
        justifyContent="space-between"
        alignItems="center"
      >
        <Box>
          <Typography variant="body2" color="text.secondary">
            Edit Unified Field
          </Typography>

          <Typography variant="body1">
            <Box sx={{ pr: 1 }} component="span">
              <UnifiedFieldIcon fill="currentColor" />
            </Box>
            {name}
          </Typography>
        </Box>
        <Button
          variant="text"
          color="primary"
          LinkComponent={Link}
          href={UNIFIED_FIELD_HELP_CENTER_DOC}
          target="_blank"
        >
          What is a Unified Field?
        </Button>
      </Stack>
    </Paper>
  );
};
